import styled from "styled-components";

export const ProgressWrapper = styled.div`
&.work-order-placement {
  .progress-container {
    width: 81px;
}
}
&.inner-pro-br{
    max-width: 188px;
}
.progress-container {
  width: 100%;
  font-family: Arial, sans-serif;
}

.progress-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2px;
}
.inner-percentage span.progress-text {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    display: flex;
    justify-content: center;
}
.progress-label {
  color: #4E5969;
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

}

.progress-text {
  color: #4E5969;
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}

.progress-bar {
  width: 100%;
  /* background-color: transparent; */
  border-radius: 10px;
  overflow: hidden;
  height: 13px;
}

.progress-fill {
  height: 100%;
  transition: width 0.3s ease-in-out;
  border-radius: 10px;
}
`
